var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"item-hint",attrs:{"no-gutters":""}},[_c('span',{staticClass:"blue--text app-text-family-sans app-text-size--extra-small"},[_c('v-icon',{staticClass:"item-hint__info-icon mr-1",attrs:{"color":"blue","size":"16"}},[_vm._v(" mdi-information-outline ")]),_vm._v(" "+_vm._s(_vm.title)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }